import { render, staticRenderFns } from "./ShowEtapaPage.vue?vue&type=template&id=a94d865c&scoped=true"
import script from "./ShowEtapaPage.vue?vue&type=script&lang=js"
export * from "./ShowEtapaPage.vue?vue&type=script&lang=js"
import style0 from "./ShowEtapaPage.vue?vue&type=style&index=0&id=a94d865c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a94d865c",
  null
  
)

export default component.exports